// Core Modules
import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { RouterLink } from '@angular/router';

// Components
import { EmptyStateComponent } from '@shared/components/empty-state/empty-state.component';

// Services
import { AccessControlService } from '@core/services/access-control/access-control.service';
import { ErrorHandlerService } from '@core/services/error-handler/error-handler.service';

// Models
import { GenericErrorHandlerModel } from '@shared/models/generic-error-handler.model';

// Enums
import { ErrorHandlerCodesEnum } from '@shared/enum/error-handler-codes.enum';

@Component({
  selector: 'app-unauthorized',
  imports: [RouterLink, EmptyStateComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './unauthorized.component.html',
})
export class UnauthorizedComponent implements OnInit {
  // Injectors
  private readonly accessControl = inject(AccessControlService);
  private readonly errorHandlerService = inject(ErrorHandlerService);

  // Private Members
  private readonly accessDeniedStatusCode: number = ErrorHandlerCodesEnum.FORBIDDEN;

  // Public Members
  public errorhandlerData?: GenericErrorHandlerModel;
  /** Where the user *can* go — without it this page is a dead end. Null when there is nowhere. */
  public readonly landingDestination = this.accessControl.landingDestination;

  public ngOnInit(): void {
    this.errorhandlerData = this.errorHandlerService.getErrorCodeData(this.accessDeniedStatusCode);
  }
}
